@if (formStep) {
  <wl-progressive-form-step-wrapper
    [rendering]="rendering"
    [title]="content.title.value"
    [stepName]="formStep?.stepId"
    [submitButtonText]="content.genericFields?.submitButtonText.value"
    submitButtonIcon="arrow-down"
    [submitButtonAutomationId]="submitButtonAutomationId"
    [progressiveFormSelectorKey]="progressiveFormSelectorKey"
    [formState]="formStep?.formState"
    [showWhenFutureStep]="false"
    [showSeperator]="false"
    [isReadonly]="isReadonly"
  >
    <ng-template wlProgressiveFormBody>
      @if (formStep?.hasGenericError) {
        <wl-error-card
          class="mb-2"
          [mode]="'content'"
          [message]="content.genericFields?.errorMessage"
        ></wl-error-card>
      }
      <wl-number
        [rendering]="rendering"
        stepName="invullen"
        [step]="currentStepIndex$ | async"
        [formsControl]="numberFormControl"
        [placeholder]="content?.numberInput?.placeholder?.value ?? ''"
      ></wl-number>
      @if (numberFormControl | isInvalid) {
        @if (numberFormControl?.errors?.isInt) {
          <wl-input-error
            stepName="invullen"
            [step]="currentStepIndex$ | async"
            [messageField]="content?.numberInput?.isIntError"
            [rendering]="rendering"
          ></wl-input-error>
        }
      }
      <wl-more-info-button
        [explanation]="content.explanation"
        [rendering]="rendering"
        (giveMoreInfo)="giveMoreInfo.emit(content?.explanation)"
      ></wl-more-info-button>
    </ng-template>

    <ng-template wlProgressiveFormSummary>
      {{ formStep?.formState?.value?.field }}
    </ng-template>
  </wl-progressive-form-step-wrapper>
}
